import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SERVICES, SERVICE_DETAILS, IMAGES } from "@/data/site";
import { usePageMeta, PageHero, SectionLabel, CTABanner } from "@/components/common";

const CATEGORIES = ["stucco-repair", "new-stucco-installation", "stucco-textures-finishes", "plaster-interior-finishes", "residential-stucco", "commercial-stucco"];

export default function Services() {
  usePageMeta("Stucco Services", "Full-service stucco contractor in Central Florida: stucco installation, repair, remediation, textures, waterproofing, interior & exterior plaster. Free estimates.");
  return (
    <div data-testid="services-page">
      <PageHero label="Our Services" title="Complete stucco & plastering services" subtitle="From new construction to expert repairs and custom finishes — one trusted contractor for all your stucco needs." image={IMAGES.texture} />

      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Featured Services</SectionLabel>
          <h2 className="text-4xl font-heading font-extrabold mt-6 mb-14">Explore our specialties</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {CATEGORIES.map((slug) => {
              const s = SERVICE_DETAILS[slug];
              return (
                <Link key={slug} to={`/services/${slug}`} data-testid={`svc-${slug}`} className="group border border-zinc-200 bg-white hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
                  <div className="relative h-48 overflow-hidden">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-heading font-bold">{s.title}</h3>
                    <p className="text-zinc-600 mt-2 text-sm leading-relaxed">{s.tagline}</p>
                    <span className="text-adn-red text-sm font-semibold mt-4 flex items-center gap-2">Learn more <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" /></span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 bg-adn-off">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Everything We Offer</SectionLabel>
          <h2 className="text-4xl font-heading font-extrabold mt-6 mb-12">Full range of stucco & plaster solutions</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-1">
            {SERVICES.map((s, i) => (
              <Link key={i} to={`/services/${s.slug}`} data-testid={`svc-list-${i}`} className="flex items-center gap-3 py-4 border-b border-zinc-200 text-zinc-700 hover:text-adn-red transition-colors group">
                <Check size={18} className="text-adn-red shrink-0" />
                <span className="font-medium">{s.name}</span>
                <ArrowRight size={16} className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
